import Action from '../modules/Action';
import mask from '../modules/mask';


export default class FormValidation {
  constructor () {

    this.options = {
      activeClass: 'js--init',
    };
    this.$el = $('form.js--validation:not(.' + this.options.activeClass + '), form.js--validate:not(.' + this.options.activeClass + '), form.validate:not(.' + this.options.activeClass + '), form.js-validation:not(.' + this.options.activeClass + ')');

    return this;
  }


  init () {
    let _this = this;


    _this.$el.each(function (index, element) {
      let array = {warnText: null, response: null},
        $this = $(element),
        settings = [],
        data = $this.data('submit'),
        dataFail = $this.data('submit-fail'),
        dataSuccess = $this.data('submit-success');

      array = $this.data('array') || array;

      if ($this.data('settings')) settings = $this.data('settings');
      settings.invalidHandler = function () {
        $this.ajaxSubmit({
          data: {isNaked: 1},
          success: function (response, status, xhr, Form) {
            var
              warnText = $(response).filter('.warnText'),
              all = $(response);

            if (warnText.length && warnText.length !== 'false') {
              if (array.warnText != null) $(array.warnText).html(warnText);
              else $(Form).find('.warnText').html(warnText);
            }else {
              if (array.warnText != null) $(array.warnText).html(all);
              else $(Form).find('.warnText').html(all);
            }

            new Action(dataFail);
          },
        });
      };

      settings.submitHandler = function (form) {
        let $this_form = $(form),
          $submit = $this_form.find('.js--submit-button');

        // Заблокировать кнопку
        let $submit_text = '';
        if ($submit.length) {
          $submit_text = $submit.find('.text');
          $submit.attr({'disabled': 'disabled', 'title': $submit.html()}).html('Отправка…');
          if ($submit_text) $submit_text.text('Отправка…');
          else $submit.text('Отправка…');
        }

        if (array.ajax !== 'false') {
          $(form).ajaxSubmit({
            data: {isNaked: 1},
            beforeSubmit: function (arr, $form) {
              new Action(data, $($form), $($form).formSerialize());
            },
            success: function (response, status, xhr, Form) {
              if (array.no_response !== 'false') {
                var
                  resp = (array.response ? $(response).find(array.response) : ($(response).filter('.response').length ? $(response).filter('.response') : $(response).find('.response'))),
                  warnText = ($(response).filter('#nc_modal_status').length ? $(response).filter('#nc_modal_status') : $(response).find('#nc_modal_status')),
                  all = $(response);

                if (warnText.length) {
                  if (warnText.length && warnText.length !== 'false') {
                    if (array.warnText != null) $(array.warnText).html(warnText);
                    else $this_form.find('.warnText').html(warnText);
                  }else {
                    if (array.warnText != null) $(array.warnText).html(all);
                    else $this_form.find('.warnText').html(all);
                  }
                }else {
                  if (array.selector !== false) {
                    if (resp.length && resp.length !== 'false') {
                      if (array.selector) $(array.selector).html(resp);
                      else $this_form.closest('div').html(resp);
                    }else {
                      if (array.selector) $(array.selector).html(all);
                      else $this_form.closest('div').html(all);
                    }
                  }
                }

                // Разблокировать кнопку
                if ($submit.length) {
                  let title = $submit.data('title') ? $submit.data('title') : $submit.attr('title');
                  $submit.removeAttr('disabled').html(title);
                  if ($submit_text) $submit_text.html(title);
                  else $submit.html($submit.attr('title'));
                }

                if (array.history) history.pushState(null, null, $(form).attr('action') + '?' + $(form).formSerialize());
              }

              new Action(dataSuccess, $(Form), $(Form).formSerialize());
              _this.render();
              mask();

            },
          });
        }
      };

      $this.addClass(_this.options.activeClass).validate(settings);
    });

  }


  render () {
    if (this.$el.length) {
      this.init();
    }
    return this;
  }
}
